import { render, staticRenderFns } from "./ReminderListItem.vue?vue&type=template&id=04cde0d6&scoped=true"
import script from "./ReminderListItem.vue?vue&type=script&lang=js"
export * from "./ReminderListItem.vue?vue&type=script&lang=js"
import style0 from "./ReminderListItem.vue?vue&type=style&index=0&id=04cde0d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cde0d6",
  null
  
)

export default component.exports